// extracted by mini-css-extract-plugin
export default {"avatar":"PhotoFeedPage_avatar__yWPMO","starTable":"PhotoFeedPage_starTable__A7g6Y"};